import React from 'react';

import AppRoutes from './AppRoutes'
import './App.css';

function App() {
  
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;
